export const meAvatarTriggerTooltipTextString = "SfUK9";
export default {meAvatarTriggerTooltipTextString};